
import { openModal } from '@ds/components/ModalBase'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import SwapModal from '@buyback/customer/swap/components/Modal'
import SwapModalV2 from '@buyback/customer/swap/components/SwapModal'
import { MODAL_NAMES } from '@config/constants'
import { ROUTES } from '@router'

import Accessories from '../Accessories'
import AdditionalInfo from '../AdditionalInfo'
import ReassuranceBlock from '../ReassuranceBlock'
import SellerBlock from '../SellerBlock'
import SellerComment from '../SellerComment'
import SwapBlock, { SWAP_DISABLED } from '../SwapBlock'
import VatBlock from '../VatBlock'

export default {
  components: {
    Accessories,
    AdditionalInfo,
    ReassuranceBlock,
    SellerComment,
    SellerBlock,
    SwapModal,
    SwapModalV2,
    SwapBlock,
    VatBlock,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },

    offer: {
      type: Object,
      required: true,
    },

    swapOffer: {
      type: Object,
      default: () => ({}),
    },

    swapStatus: {
      type: String,
      required: true,
    },

    technicalSpecifications: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      swapPayload: {},
      swapRedirection: ROUTES.PRODUCT.HOME,
    }
  },

  computed: {
    ROUTES: () => ROUTES,
    ...mapGetters({
      isVatIncluded: 'config/vatIncluded',
    }),

    modelTitle() {
      return this.product.rawTitle
    },

    swapOfferPrice() {
      return this.swapOffer.price ?? ''
    },

    productId() {
      const { uuid } = this.$route.params

      return uuid
    },

    isAccessory() {
      return this.product.type === 'accessory'
    },

    accessories() {
      return !isEmpty(this.technicalSpecifications)
        ? this.technicalSpecifications.comesWith.items ?? []
        : []
    },

    showExcludedAccessoriesModal() {
      return !isEmpty(this.technicalSpecifications)
        ? this.technicalSpecifications.comesWith.displayAccessoryExclusionsModal
        : false
    },

    displaySellerBlock() {
      return !this.isAccessory
    },

    hasSwapOffer() {
      return !isEmpty(this.swapOffer)
    },

    shouldDisplaySwap() {
      return this.swapStatus !== SWAP_DISABLED
    },

    category() {
      return (
        this.product.trackingDetails &&
        this.product.trackingDetails.category3Name
      )
    },

    swapModal: () => MODAL_NAMES.BUYBACK.SWAP_PRODUCT,

    swapModalATC: () => MODAL_NAMES.BUYBACK.SWAP_ATC,

    redirectModal: () => MODAL_NAMES.PRODUCT.ADD_TO_CART,

    shouldDisplaySwapModalV2() {
      return this.$config.FF_BUYBACK_SWAP_API_V3
    },
  },
  methods: {
    handleContinue() {
      setTimeout(() => {
        openModal(this.redirectModal)
      })
    },
  },
}
